import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import LoadingSpinner from '../components/common/LoadingSpinner';
import api from '../services/api';
import { formatDate } from '../utils/helpers';

const BlogPostPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [blogPost, setBlogPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogPost = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/blog-posts/${slug}/`);
        setBlogPost(response.data);
      } catch (err) {
        console.error('Failed to load blog post:', err);
        setError('Blog post not found');
      } finally {
        setLoading(false);
      }
    };

    fetchBlogPost();
  }, [slug]);

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  if (error || !blogPost) {
    return (
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Blog post not found</h2>
        <Link
          to="/"
          className="text-blue-600 hover:underline"
        >
          Return to home
        </Link>
      </div>
    );
  }


  return (
    <div
      className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12"
      style={{ fontFamily: "'Poppins', system-ui, sans-serif" }}
    >
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          {blogPost.title}
        </h1>
        <p className="text-gray-500 text-sm">
          Last updated: {formatDate(blogPost.updated_at)}
        </p>
      </div>

      {/* Content */}
      <div className="prose prose-lg max-w-none">
        <ReactMarkdown>
          {blogPost.content}
        </ReactMarkdown>
      </div>

      {/* Back link */}
      <div className="mt-12 pt-8 border-t border-gray-200">
        <button
          onClick={() => navigate(-1)}
          className="text-gray-600 hover:text-gray-900 flex items-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back
        </button>
      </div>
    </div>
  );
};

export default BlogPostPage;